import { useTranslation } from "react-i18next";
import { MdContentCopy } from "react-icons/md";
import { useUID } from "../../../context/UIDContext";
import { useAmplitude } from "../../../context/AmplitudeContext";
import "./ProductCards.scss";

export const ProductCards = ({ products, onShowMoreClick }) => {
  const { t } = useTranslation("productModule");
  const { uid } = useUID();
  const trackEvent = useAmplitude();

  // track product click event
  const trackProductClick = (productTitle, productUrl) => {
    trackEvent(
      "webapp_user_clicked_product",
      uid,
      "",
      "",
      productTitle,
      productUrl,
    );
  };

  return (
    <div className="product-cards">
      {products.map((product, index) => (
        <div
          key={index}
          className="product-card"
          onClick={() => {
            trackProductClick(product.name, product.url);
            if (product.score !== undefined) {
              onShowMoreClick(product);
            }
          }}
        >
          <div className="product-img-container">
            <img
              src={product.image}
              alt={product.name}
              className={
                !product.imageUrl && !product.image
                  ? "placeholder"
                  : "product-img"
              }
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: "100%",
              justifyContent: "flex-start",
              gap: "8px",
            }}
          >
            <h4 className="product-brand">
              {product.brand === "" ? "\u00A0" : product.brand}
            </h4>
            {product.name && <h4 className="product-title">{product.name}</h4>}

            {product.price && (
              <div className="product-price-wrapper">
                <h4 className="current-product-price">
                  {product.discountPrice !== undefined
                    ? product.discountPrice
                    : product.price}
                </h4>
                {product.discountPrice && (
                  <div className="original-product-price">
                    {product.price}
                    <div className="strike-through-line" />
                  </div>
                )}
              </div>
            )}

            {product.promoCode && (
              <p className="product-promo-code">
                <span className="promo-prefix">{t("promo-code-prefix")}</span>{" "}
                <span className="promo-value">{product.promoCode}</span>
                <MdContentCopy
                  className="copy-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigator.clipboard?.writeText(product.promoCode);
                  }}
                />
              </p>
            )}

            {product.url && (
              <h4
                className="product-to-link-button"
                onClick={(e) => {
                  e.stopPropagation();
                  if (product.url) {
                    const newWindow = window.open(
                      product.url,
                      "_blank",
                      "noopener,noreferrer",
                    );
                    if (newWindow) newWindow.opener = null;
                  }
                }}
              >
                {t("product-details")}
              </h4>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
